import { PathologyItem } from '../../Enums/PathologyItem.enum';

export interface PathologyOption {
	label: string;
	value: PathologyItem;
}

export const PATHOLOGY_BUTTON_OPTIONS: PathologyOption[] = [
	{
		label: 'patientTreatment.meddiDENT.dentalCross.pathologyModal.decay.title',
		value: PathologyItem.DECAY,
	},
	{
		label:
			'patientTreatment.meddiDENT.dentalCross.pathologyModal.rootDecay.title',
		value: PathologyItem.ROOT_DECAY,
	},
	{
		label:
			'patientTreatment.meddiDENT.dentalCross.pathologyModal.fracture.title',
		value: PathologyItem.FRACTURE,
	},
	{
		label:
			'patientTreatment.meddiDENT.dentalCross.pathologyModal.toothWear.title',
		value: PathologyItem.TOOTH_WEAR,
	},
	{
		label:
			'patientTreatment.meddiDENT.dentalCross.pathologyModal.discoloration.title',
		value: PathologyItem.DISCOLORATION,
	},
	{
		label: 'patientTreatment.meddiDENT.dentalCross.pathologyModal.apical.title',
		value: PathologyItem.APICAL,
	},
	{
		label:
			'patientTreatment.meddiDENT.dentalCross.pathologyModal.developmentDisorder.title',
		value: PathologyItem.DEVELOPMENT_DISORDER,
	},
];
